f
<template>
	<v-card-text class="pa-10">
		<v-layout row wrap>
			<v-flex md3>
				<v-img class="elevation-1" :src="producto.image_url" contain height="300px"></v-img>
				<v-slide-group multiple show-arrows class="py-3 px-0">
					<v-slide-item v-for="img in producto.images" :key="img.id" class="px-2">
						<v-img
							style="cursor: pointer"
							v-ripple="true"
							:src="img.url"
							@click="producto.image_url = img.url"
							height="80px"
							width="80px"
							contain
						></v-img>
					</v-slide-item>
				</v-slide-group>
			</v-flex>
			<v-flex md5 class="px-10">
				<h2 class="text-center">{{ producto.name }}</h2>
				<br />
				<span class="text-justify"><b>Referencia</b>: {{ producto.referencia }}</span>
				<br />
				<span class="text-justify"><b>Condición</b>: <span class="green--text">Nuevo</span></span>
				<br />
				<span v-if="producto.mostrar_stock" class="text-justify"><b>Stock</b>: {{ producto.stock | number }}</span>
				<span v-else class="text-justify green--text"> {{ producto.stock > 0 ? "Stock Disponible" : "" }}</span>
				<br />
				<br />
				<div v-html="producto.description" v-if="producto.description"></div>
				<div v-else>Sin Descripcion</div>
				<div style="height: 100px">&nbsp;</div>
				<b>Compartir en:</b>
				<br />
				<ShareNetwork
					network="facebook"
					:url="`${api.url.replace('public', 'store')}#/product/${producto.referencia}`"
					:title="producto.name"
					:description="producto.description"
					:quote="producto.name"
					:hashtags="`${producto.name},${settings.nombre_empresa}`"
				>
					<v-btn icon color="blue"><v-icon>mdi-facebook</v-icon></v-btn>
				</ShareNetwork>
				<ShareNetwork
					network="twitter"
					:url="`${api.url.replace('public', 'store')}#/product/${producto.referencia}`"
					:title="producto.name"
					:description="producto.description"
					:quote="producto.name"
					:hashtags="`${producto.name},${settings.nombre_empresa}`"
				>
					<v-btn icon color="cyan"><v-icon>mdi-twitter</v-icon></v-btn>
				</ShareNetwork>
				<ShareNetwork
					network="whatsapp"
					:url="`${api.url.replace('public', 'store')}#/product/${producto.referencia}`"
					:title="producto.name"
					:description="producto.description"
					:quote="producto.name"
					:hashtags="`${producto.name},${settings.nombre_empresa}`"
				>
					<v-btn icon color="green"><v-icon>mdi-whatsapp</v-icon></v-btn>
				</ShareNetwork>
				<ShareNetwork
					network="LinkedIn"
					:url="`${api.url.replace('public', 'store')}#/product/${producto.referencia}`"
					:title="producto.name"
					:description="producto.description"
					:quote="producto.name"
					:hashtags="`${producto.name},${settings.nombre_empresa}`"
				>
					<v-btn icon color="#006291"><v-icon>mdi-linkedin</v-icon></v-btn>
				</ShareNetwork>
				<ShareNetwork
					network="email"
					:url="`${api.url.replace('public', 'store')}#/product/${producto.referencia}`"
					:title="producto.name"
					:description="producto.description"
					:quote="producto.name"
					:hashtags="`${producto.name},${settings.nombre_empresa}`"
				>
					<v-btn icon color="red"><v-icon>mdi-email</v-icon></v-btn>
				</ShareNetwork>

				<ShareNetwork
					network="sms"
					:url="`${api.url.replace('public', 'store')}#/product/${producto.referencia}`"
					:title="producto.name"
					:description="producto.description"
					:quote="producto.name"
					:hashtags="`${producto.name},${settings.nombre_empresa}`"
				>
					<v-btn icon color="blue"><v-icon>mdi-android-messages</v-icon></v-btn>
				</ShareNetwork>
			</v-flex>
			<v-flex md4>
				<h2 class="py-2 text-center">
					{{ "price" | trans }}:
					{{ (producto.precio + (producto.precio * producto.impuesto) / 100) | money }}
				</h2>
				<label>{{ "quantity" | trans }}</label>
				<v-layout row class="pa-2">
					<v-btn depressed style="height: 40px" @click="addProduct(-1)"><v-icon>mdi-minus</v-icon></v-btn>
					<v-text-field
						v-model.number="quantity"
						type="number"
						min="0"
						style="width: 100px"
						dense
						outlined
						flat
						single-line
					></v-text-field>
					<v-btn depressed style="height: 40px" @click="addProduct(1)"><v-icon>mdi-plus</v-icon></v-btn>
				</v-layout>
				<stock-selector class="my-1" :product="producto" v-model="stockSelected"></stock-selector>
				<v-btn
					block
					:disabled="producto.advanced_stock && producto.advanced_stock.length > 0 && (!stockSelected || quantity <= 0)"
					large
					depressed
					color="primary"
					dark
					@click="addToCart"
				>
					<v-icon left> mdi-cart-plus</v-icon>
					Agregar al Carrito
				</v-btn>
				<v-btn block large depressed color="success" class="mt-1" dark :to="`/product/${producto.referencia}`">
					<v-icon left> mdi-web</v-icon>
					Ir a la Pagina
				</v-btn>
			</v-flex>
		</v-layout>
	</v-card-text>
</template>
<script>
import StockSelector from "@/components/StockSelector";
export default {
	components: { StockSelector },
	async mounted() {
		this.settings = await this.api.loadSettings();
	},
	data() {
		return {
			settings: {
				collection: {},
			},
			producto: {},
			stockSelected: null,
			quantity: 1,
		};
	},
	methods: {
		addProduct(qty = 1) {
			this.quantity += qty;
			if (this.quantity < 0) this.quantity = 0;
		},
		addToCart() {
			this.$set(this.producto, "cantidad_pedidos", this.quantity);
			this.api.cart.addToCart(this.producto, false, this.stockSelected);
		},
	},
	props: ["product"],
	watch: {
		product: {
			immediate: true,
			async handler() {
				this.producto = this.product;
				this.producto = await this.api.load(`productos/${this.producto.id}?include=images,categoria`);
				this.producto.impuesto = parseFloat(this.producto.impuesto);
				if (!this.producto.images.find((i) => i.id == this.producto.image_id)) {
					this.producto.images.unshift({
						id: this.producto.image_id,
						url: this.producto.image_url,
					});
				}
				var item = this.api.cart.find((i) => i.id == this.producto.id);
				if (item) this.quantity = item.cantidad_pedidos;
			},
		},
	},
};
</script>
